module.exports = __webpack_public_path__ + "img/s&s.7360cc94.png";